import { produce } from 'immer';
import {
  INFORMES_IMPRIMIR_END,
  INFORMES_IMPRIMIR_START,
} from '../actions/constants/informes.constants';

const initialState = {
  queue: {},
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INFORMES_IMPRIMIR_START: {
      const { informeId, plantillaId } = payload;
      draft.queue[`${informeId}_${plantillaId}`] = { running: true };
      return draft;
    }
    case INFORMES_IMPRIMIR_END: {
      const { informeId, plantillaId } = payload;
      draft.queue[`${informeId}_${plantillaId}`] = { running: false };
      return draft;
    }
    default:
      return draft;
  }
});
